import { useState, useEffect } from "react";

const useExpandTableHeight = (offset = 290) => {
  const [expandTableHeight, setExpandTableHeight] = useState(() => globalThis.innerHeight - offset);

  useEffect(() => {
    const handleResize = () => setExpandTableHeight(globalThis.innerHeight - offset);

    globalThis.addEventListener("resize", handleResize);
    return () => globalThis.removeEventListener("resize", handleResize);
  }, [offset]);

  return expandTableHeight;
};

export default useExpandTableHeight;
